'use strict';
document.querySelector('.form').addEventListener('submit', function(e) {
    e.preventDefault();
    e.target.reset();
    window.scrollTo(0, 0);
});

//# sourceMappingURL=Museum_2.e78acf11.js.map
